<template>
  <v-card tile>
    <loader v-if="$wait.is('getUposlenikDetails')" class="pt-12"></loader>
    <v-card-text v-else-if="selectedStudent"  
    class="pa-12 pt-0">
        <v-row no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Ime i prezime</h3> </v-col
          ><v-col>
            <h4 style="color: black; text-transform: capitalize;" class="pt-2" >
              {{ titleCase(selectedStudent.ime)}} {{ titleCase(selectedStudent.prezime)}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.djevojacko_prezime"></v-divider>
        <v-row v-if="selectedStudent.djevojacko_prezime" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Djevojačko prezime</h3> </v-col
          ><v-col>
            <h4 style="color: black; text-transform: capitalize;" class="pt-2">
              {{ titleCase(selectedStudent.djevojacko_prezime)}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.jmbg && hasAdminRights"></v-divider>
        <v-row v-if="selectedStudent.jmbg && hasAdminRights"  no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">JMBG</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.jmbg}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.oib"></v-divider>
        <v-row v-if="selectedStudent.oib" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">OIB</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.oib}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.ime_oca"></v-divider>
        <v-row v-if="selectedStudent.ime_oca" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118);">Ime oca</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ titleCase(selectedStudent.ime_oca)}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.ime_majke"></v-divider>
        <v-row v-if="selectedStudent.ime_majke" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Ime majke</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ titleCase(selectedStudent.ime_majke)}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.mjesto_rodjenja"></v-divider>
        <v-row v-if="selectedStudent.mjesto_rodjenja" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Mjesto rođenja</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.mjesto_rodjenja}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.opcina_rodjenja"></v-divider>
        <v-row v-if="selectedStudent.opcina_rodjenja" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Općina rođenja</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.opcina_rodjenja}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.djevojacko_prezime_majke"></v-divider>
        <v-row v-if="selectedStudent.djevojacko_prezime_majke" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118); ">Djevojačko prezime majke</h3> </v-col
          ><v-col>
            <h4 style="color: black; text-transform: capitalize;" class="  pt-2">
              {{ titleCase(selectedStudent.djevojacko_prezime_majke)}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.datum_rodjenja"></v-divider>
        <v-row v-if="selectedStudent.datum_rodjenja" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Datum rođenja</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.datum_rodjenja | moment('DD. MMMM, YYYY')}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.e_mail"></v-divider>
        <v-row v-if="selectedStudent.e_mail" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">E-mail</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.e_mail}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.mobitel"></v-divider>
        <v-row v-if="selectedStudent.mobitel" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Mobitel</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.mobitel}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.telefon"></v-divider>
        <v-row v-if="selectedStudent.telefon" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Telefon</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.telefon}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.aai_kor_ime"></v-divider>
         <v-row v-if="selectedStudent.aai_kor_ime" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">AAI korisničko ime</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.aai_kor_ime}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.aai_email"></v-divider>
        <v-row v-if="selectedStudent.aai_email" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">AAI e-mail</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.aai_email}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.website"></v-divider>

        <v-row v-if="selectedStudent.website" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Website</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.website}}
            </h4></v-col
          ></v-row>
         <v-divider v-if="selectedStudent.description"></v-divider>
        
        <v-row v-if="selectedStudent.description" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Opis</h3> </v-col
          ><v-col>
            <p v-html="selectedStudent.description"></p>
            </v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.scholar"></v-divider>
        <v-row v-if="selectedStudent.scholar" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Scholar</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.scholar}}
            </h4></v-col
          ></v-row
        >
         <v-divider v-if="selectedStudent.office_number"></v-divider>
        <v-row v-if="selectedStudent.office_number" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Broj ureda</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.office_number}}
            </h4></v-col
          ></v-row
        >
        <v-divider v-if="selectedStudent.godina_zavrsetka_sse"></v-divider>
        <v-row v-if="selectedStudent.godina_zavrsetka_sse" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)">Godina završetka sse</h3> </v-col
          ><v-col>
            <h4 style="color: black" class="  pt-2">
              {{ selectedStudent.godina_zavrsetka_sse}}
            </h4></v-col
          ></v-row
        >
             <v-divider v-if="selectedStudent.znanstveni_radovi.length"></v-divider>

        <v-row v-if="selectedStudent.znanstveni_radovi.length>0" no-gutters class="pb-2 pt-5">
          <v-col cols="12">
            <h3 style="color: rgb(8, 71, 118)" class="pb-2">Znanstveni radovi</h3> </v-col
          ><v-col>
           
             <v-card style="cursor:pointer"  elevation="1" class="pa-0 mb-3" color="accent" v-for="item in selectedStudent.znanstveni_radovi" :key="item.id">
            <v-card-title @click="goToRad(item)"
            v-if="item.verificiran == '1' || hasAdminRights"
              class="d-flex justify-center align-center pa-0 pr-3 pl-3" 
            >
              <h5 >
                {{item.naslov }}
              </h5>
              <v-spacer></v-spacer>
              <v-btn fab icon >
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-title>
             </v-card>
            </v-col
          ></v-row
        >
    </v-card-text>
     <v-dialog
      fullscreen
      v-model="editRadDialog"
    >
      <v-toolbar color="rgb(8, 71, 118)" flat v-if="selectedRad">
        <v-icon
          :disabled="$wait.is('verifikacija')"
          @click="closeDetails"
          class="mr-2 ml-0"
          color="white" left
          >mdi-close</v-icon
        >
        <h4 v-if="$vuetify.breakpoint.mdAndUp" style="color: white">
          {{ selectedRad.naslov }}
        </h4>
      </v-toolbar>
      <detalji-rada 
    class="pa-12 pt-0"></detalji-rada>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";

export default {
  // metaInfo: {
  //     title: 'Detalji o studentu  - Registar radova'
  //   },
    props:["selectedStudent"],
    computed:{
       ...mapGetters(["hasAdminRights"]),
    },
  methods:{
    titleCase(str) {
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   return splitStr.join(' '); 
},
 goToRad(item) {
      this.selectedRad = item;
      waitFor("getRadDetails", async function () {
        await this.$store.dispatch("fetchRad", item.id);
      }).apply(this);

      this.editRadDialog = true;
    },
    async closeDetails() {
      this.editRadDialog = false;
    },
  },
  data: () => ({
    selectedRad: {},
    editRadDialog: false,

  })
};
</script>